module.exports = __webpack_public_path__ + "6f112ec.v5.1.2.woff2";